'use client';

import { Button } from '@shared/components/shadcn';
import type { OfferGroup } from '../../helpers/offerHelpers';
import { useOfferTimer } from '../../hooks/useOfferTimer';
import { getOfferContinueButtonTrackingAttributes } from '../../utils/offerUtils';
import { BrowseGamesButton } from '../BrowseGamesButton/BrowseGamesButton';
import { OfferLoginButtons } from '../OfferLoginButtons/OfferLoginButtons';

type OfferInlineButtonsProps = {
  shouldShowLoginButtons: boolean;
  offerGroup: OfferGroup;
  onStepAction?: () => void;
  buttonLoading: string | null;
  stepCode?: string;
  className?: string;
};

function OfferInlineButtons({ shouldShowLoginButtons, offerGroup, onStepAction, buttonLoading, stepCode, className }: OfferInlineButtonsProps) {
  const { currentAction, currentButtonText, currentButtonDisabled, currentProducts, offer, activeStepIndex } = offerGroup;
  const { availableFrom, steps } = offer;

  const productIds = currentProducts instanceof Array ? (currentProducts as string[]) : undefined;
  const currentStep = activeStepIndex !== null && steps ? steps[activeStepIndex]?.label : undefined;
  const offerValidFrom = availableFrom ? new Date(availableFrom) : undefined;

  const { getTimerButtonText, isTimerDisabled } = useOfferTimer(offerValidFrom);

  if (!currentAction || !currentButtonText) {
    return null;
  }

  if (shouldShowLoginButtons) {
    return (
      <div className={className} data-testid="offer-inline-buttons" data-track-container="Actions">
        {shouldShowLoginButtons ? <OfferLoginButtons offerValidFrom={offerValidFrom} buttonLoading={buttonLoading} /> : null}
      </div>
    );
  }

  return (
    <div className={className} data-testid="offer-inline-buttons" data-track-container="Actions">
      {shouldShowLoginButtons ? <OfferLoginButtons offerValidFrom={offerValidFrom} buttonLoading={buttonLoading} /> : null}

      {productIds?.length ? (
        <BrowseGamesButton gamesNames={productIds} />
      ) : (
        <Button
          variant="primary"
          onClick={() => onStepAction?.()}
          disabled={buttonLoading !== null || currentButtonDisabled || isTimerDisabled()}
          className="w-full md:w-auto"
          {...getOfferContinueButtonTrackingAttributes(currentStep, stepCode, currentAction)}
        >
          {getTimerButtonText(currentButtonText)}
        </Button>
      )}
    </div>
  );
}

export { OfferInlineButtons, type OfferInlineButtonsProps };
